import { InvoiceCapReachedModal } from './InvoiceCapReachedModal';

export default InvoiceCapReachedModal;
